
import Vue from "vue";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle/TempStarsTableTitle.vue";
import { syncCoursesToDatabase } from "@/api";

interface SyncResult {
  environment: string;
  total: number;
  inserted: number;
  updated: number;
  skipped: number;
  syncedAt: string;
  errors: Array<{ lmsCourseId: number | null; message: string }>;
}

export default Vue.extend({
  name: "Courses",
  components: {
    TempStarsTableTitle
  },
  data: () => ({
    loading: false,
    lastResult: null as SyncResult | null,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success"
  }),
  methods: {
    async runSync() {
      this.loading = true;
      try {
        const result: SyncResult = await syncCoursesToDatabase();
        this.lastResult = result;
        const hasErrors = result.errors && result.errors.length > 0;
        this.showSnackbar(
          hasErrors
            ? `Synced with ${result.errors.length} error(s)`
            : `Synced ${result.total} courses successfully`,
          hasErrors ? "warning" : "success"
        );
      } catch (error) {
        const err = error as any;
        this.showSnackbar(
          `Failed to sync courses: ${err.message || err}`,
          "error"
        );
      } finally {
        this.loading = false;
      }
    },
    formatTime(iso: string): string {
      try {
        return new Date(iso).toLocaleString();
      } catch (_) {
        return iso;
      }
    },
    showSnackbar(text: string, color: string) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    }
  }
});
